export const navigation = {
  about: "À propos",
  activities: "Journal d'activité",
  administration: "Administration",
  assets: "Actifs",
  assetTypes: "Types d'actifs",
  browse: "Naviguer par",
  collapse: "Rétracter",
  dashboard: "Tableau de bord",
  events: "Mes événements",
  expand: "Étendre",
  import: "Outil d'importation",
  interventions: "Interventions",
  interventionTemplates: "Gabarits d'intervention",
  language: "Langue",
  locations: "Localisations",
  logout: "Déconnexion",
  mySpace: "Mon espace",
  observations: "Observations",
  organizations: "Organisations",
  pageError: {
    notFound: {
      title: "La page que vous recherchez n'existe pas.",
      description:
        "Il est possible qu'elle ait été déplacée, renommée ou supprimée.",
    },
    contextNotFound: {
      title: "Problème avec l'organisation",
      description:
        "L'organisation que vous tentez d'accéder n'existe pas, a été supprimée ou bien vous n'y avez pas accès.",
    },
    default: {
      title: "Une erreur s'est produite",
      description:
        "N'hésitez pas à <HelpLink>contacter le support</HelpLink> si nécessaire.",
    },
    returnToDashboard: "Retourner au tableau de bord",
    returnToLogin: "Retourner à la page de connexion",
  },
  preferences: "Préférences",
  preferencesNotifications: "Préférences de notification",
  preferencesPassword: "Changer le mot de passe",
  projects: "Projets",
  support: "Support",
  technicalForms: "Formulaires techniques",
  users: "Utilisateurs",
};
